import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiBadgedContent, TuiBadgeNotification } from '@taiga-ui/kit';
import { TuiScrollbar, TuiScrollable, TuiHint } from '@taiga-ui/core';
import { WaIntersectionObserver } from '@ng-web-apis/intersection-observer';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@src/app/shared';
import { PhotoModule } from '@src/app/modules/photo';
import { ComponentsModule } from '@src/app/components';
import { IconModule } from '@src/app/modules/icon';

import {
  ListItemModerationUserComponent,
  ListItemOrganisationComponent,
  ListItemBirthdaysUserComponent,
  ListItemUserComponent,
  ListItemChatMemberComponent,
  ListItemPollComponent,
  ListItemEventComponent,
  ListItemGroupComponent,
  ListItemCommitteeComponent,
} from './components';
import { ListComponent } from './list.component';

@NgModule({
  declarations: [
    ListComponent,
    ListItemModerationUserComponent,
    ListItemOrganisationComponent,
    ListItemBirthdaysUserComponent,
    ListItemOrganisationComponent,
    ListItemUserComponent,
    ListItemChatMemberComponent,
    ListItemPollComponent,
    ListItemEventComponent,
    ListItemGroupComponent,
    ListItemCommitteeComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    PhotoModule,
    SharedModule,
    TuiScrollbar,
    TuiScrollable,
    TranslateModule,
    ...WaIntersectionObserver,
    IconModule,
    ...TuiBadgedContent,
    TuiBadgeNotification,
    ...TuiHint,
  ],
  exports: [
    ListComponent,
    ListItemModerationUserComponent,
    ListItemOrganisationComponent,
    ListItemBirthdaysUserComponent,
    ListItemUserComponent,
    ListItemChatMemberComponent,
    ListItemPollComponent,
    ListItemEventComponent,
    ListItemGroupComponent,
    ListItemCommitteeComponent,
  ],
})
export class NewListModule {}
